<p>add-partnerpay works!</p>
